import { render, staticRenderFns } from "./SelfPublishingFlowQuoteFooterImprimBook.vue?vue&type=template&id=ec735346&scoped=true&"
import script from "./SelfPublishingFlowQuoteFooterImprimBook.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowQuoteFooterImprimBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec735346",
  null
  
)

export default component.exports